import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M5 8h10v8H5z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7zm-2 9H5V8h10v8z"
})), 'VideocamTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VideocamTwoTone.js
// module id = 7059
// module chunks = 2